import type { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useEAFDETablesStyles = makeStyles((theme: Theme) => ({
	agGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		minHeight: "349px",
		maxHeight: "349px",
	},
	upperAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 10px 50px 10px",
		minHeight: "578px",
		maxHeight: "578px",
	},
	middleTextfields: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 6px 10px 6px",
		minHeight: "230px",
		maxHeight: "230px",
	},
	dynamicHeight: {
		height: (props?: { rowCount?: number }) => {
			const rowCount = props?.rowCount ?? 4;
			return `${Math.min(350 + (rowCount - 4) * 50, 550)}px`;
		},
		// 350px base for 4 rows, 50px for each additional row, maximum 550px (for 8 rows)
	},
	readonlyAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px",
		height: "400px",
		minHeight: "400px",
	},
	electrodeEventsAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "230px",
		minHeight: "230px",
	},
	lowerAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "468px",
		minHeight: "468px",
	},
	// Specific table heights for exact row counts
	probesAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "295px", // 5 rows
		minHeight: "295px",
	},
	additionsAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "257px", // 4 rows
		minHeight: "250px",
	},
	wireAdditionsAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "195px", // 2 rows
		minHeight: "195px",
	},
	heatingsAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "524px", // 10 rows
		minHeight: "524px",
	},
	chargesAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "260px", // 4 rows
		minHeight: "260px",
	},
	phasesAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "325px", // 6 rows
		minHeight: "325px",
	},
	electrodesAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "165px", // 1 row
		minHeight: "165px",
	},
	manualAutoButton: {
		minWidth: "5px",
		padding: "6px 8px",
		cursor: "auto",
	},
	smAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 10px 10px 10px",
		height: "281px",
		minHeight: "350px",
	},
	headerTableStyles: {
		fontSize: "1rem",
	},
	// Notes
	outlinedTextarea: {
		width: "100%",
		padding: "10px 12px",
		border: `1px solid ${theme.palette.grey[400]}`,
		borderRadius: theme.shape.borderRadius,
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.fontSize,
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		"&:hover": {
			borderColor: theme.palette.text.primary,
		},
		"&:focus": {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
			outline: "none",
		},
		"&::placeholder": {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
}));

export const useManualAutoButtonStyles = makeStyles((theme: Theme) => ({
	manualAutoButton: {
		minWidth: "5px",
		width: "25px",
		height: "25px",
		minHeight: "25px !important",
		maxHeight: "25px",
		padding: "6px 8px",
		cursor: "auto",
	},
}));
